import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "./i18n";

ReactDOM.render(<App />, document.getElementById("root"));

// Temporary runtime error capture + on-screen overlay to help debug mobile Safari
// - saves last error to localStorage key 'lastAppError'
// - renders a visible red overlay with the error message so it can be seen on devices

// (function attachRuntimeErrorOverlay() {
// 	function formatError(e: any): string {
// 		try {
// 			if (!e) return "Unknown error";
// 			if (e instanceof Error)
// 				return (e.stack || e.message || String(e)).toString();
// 			if (typeof e === "string") return e;
// 			if (e && e.reason) return formatError(e.reason);
// 			return JSON.stringify(e);
// 		} catch (ex) {
// 			return String(e);
// 		}
// 	}

// 	function showOverlay(text: string) {
// 		try {
// 			const existing = document.getElementById("__app_error_overlay");
// 			if (existing) {
// 				existing.textContent = text;
// 				return;
// 			}

// 			const el = document.createElement("div");
// 			el.id = "__app_error_overlay";
// 			el.style.position = "fixed";
// 			el.style.left = "6px";
// 			el.style.right = "6px";
// 			el.style.bottom = "6px";
// 			el.style.maxHeight = "60%";
// 			el.style.overflow = "auto";
// 			el.style.background = "rgba(200,40,40,0.95)";
// 			el.style.color = "white";
// 			el.style.padding = "12px";
// 			el.style.borderRadius = "8px";
// 			el.style.zIndex = "2147483647";
// 			el.style.fontSize = "12px";
// 			el.style.whiteSpace = "pre-wrap";
// 			el.textContent = text;
// 			document.body.appendChild(el);
// 		} catch (ex) {
// 			// ignore
// 		}
// 	}

// 	window.addEventListener("error", (ev) => {
// 		try {
// 			const msg =
// 				ev.message || (ev.error && ev.error.message) || "Script error";
// 			const loc = ev.filename ? `${ev.filename}:${ev.lineno}:${ev.colno}` : "";
// 			const stack = ev.error && ev.error.stack ? `\n${ev.error.stack}` : "";
// 			const text = `${msg} ${loc}${stack}`;
// 			const payload = {
// 				message: text,
// 				userAgent: navigator.userAgent,
// 				url: "",
// 				ts: Date.now(),
// 			};
// 			try {
// 				localStorage.setItem("lastAppError", JSON.stringify(payload));
// 			} catch (e) {}
// 			showOverlay(text);
// 			// also log to console
// 			// eslint-disable-next-line no-console
// 			console.error("Captured runtime error:", ev.error || ev.message || ev);
// 		} catch (e) {
// 			// swallow
// 		}
// 	});

// 	window.addEventListener("unhandledrejection", (ev) => {
// 		try {
// 			const reason = ev.reason || ev;
// 			const text = formatError(reason);
// 			const payload = {
// 				message: text,
// 				userAgent: navigator.userAgent,
// 				url: "",
// 				ts: Date.now(),
// 			};
// 			try {
// 				localStorage.setItem("lastAppError", JSON.stringify(payload));
// 			} catch (e) {}
// 			showOverlay(text);
// 			// eslint-disable-next-line no-console
// 			console.error("Captured unhandledrejection:", reason);
// 		} catch (e) {
// 			// swallow
// 		}
// 	});
// })();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
